/* bs-wishlist — favoritos nativos del tema (localStorage), SIN depender de apps/plugins.
   Reemplaza al plugin "Wishlist by Square" (antes en bs-product-carousel.js).

   Botones: cualquier elemento con clase .wishlist-button y data-product-handle
   (+ data-variant-id, data-product-id opcionales para render/enlaces).
   Estado localStorage 'bs_wishlist' = [{ h: handle, v: variantId, p: productId }].
   Estado visual: clase .is-wishlist + aria-pressed. Contador header: bs-header.js
   escucha el evento 'bs:wishlist:change' (con detail.count) y lee la misma key.
   API pública window.BSWishlist (read, has, remove) para la página de favoritos. */
(function () {
  'use strict';

  var KEY = 'bs_wishlist';

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(a) ? a : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* quota / modo privado — no bloquea la UX */
    }
    document.dispatchEvent(
      new CustomEvent('bs:wishlist:change', {
        bubbles: true,
        detail: { count: list.length },
      })
    );
  }

  function indexOf(list, handle) {
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].h === handle) return i;
    }
    return -1;
  }

  function setBtnState(btn, saved) {
    btn.classList.toggle('is-wishlist', saved);
    btn.setAttribute('aria-pressed', String(saved));
  }

  function applyAll() {
    var list = read();
    document.querySelectorAll('.wishlist-button[data-product-handle]').forEach(function (btn) {
      setBtnState(btn, indexOf(list, btn.dataset.productHandle) !== -1);
    });
  }

  function pulse(btn) {
    btn.classList.remove('is-pulsing');
    requestAnimationFrame(function () {
      btn.classList.add('is-pulsing');
    });
    setTimeout(function () {
      btn.classList.remove('is-pulsing');
    }, 420);
  }

  function toggle(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;

    var list = read();
    var i = indexOf(list, handle);
    var saved;
    if (i === -1) {
      list.push({ h: handle, v: btn.dataset.variantId || '', p: btn.dataset.productId || '' });
      saved = true;
    } else {
      list.splice(i, 1);
      saved = false;
    }
    write(list);

    /* Sincroniza TODOS los botones del mismo producto (puede haber varios en la página) */
    var sel = '.wishlist-button[data-product-handle="' + handle.replace(/"/g, '\\"') + '"]';
    document.querySelectorAll(sel).forEach(function (b) {
      setBtnState(b, saved);
      pulse(b);
    });
  }

  /* Click delegado en document: funciona en cualquier sección, presente o cargada después
     (el innerHTML de product-recommendations se swapea async — la delegación lo cubre). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  function init() {
    applyAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-aplicar tras render de secciones (customizer / carga AJAX de recomendaciones) */
  document.addEventListener('shopify:section:load', init);
  /* Sync entre pestañas del mismo navegador */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) applyAll();
  });

  /* API pública para la página de favoritos */
  window.BSWishlist = {
    read: read,
    has: function (handle) {
      return indexOf(read(), handle) !== -1;
    },
    remove: function (handle) {
      var l = read();
      var i = indexOf(l, handle);
      if (i !== -1) {
        l.splice(i, 1);
        write(l);
        applyAll();
      }
    },
    /* Quita varios handles de golpe (un solo write / evento). Lo usa la página de
       favoritos para limpiar productos borrados (404) y que el contador cuadre. */
    prune: function (handles) {
      if (!handles || !handles.length) return 0;
      var dead = {};
      for (var i = 0; i < handles.length; i++) dead[handles[i]] = true;
      var l = read();
      var kept = l.filter(function (it) {
        return it && !dead[it.h];
      });
      if (kept.length !== l.length) {
        write(kept);
        applyAll();
      }
      return l.length - kept.length;
    },
  };
})();
